import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Restaurant } from '../../../state/restaurants.models';

@Component({
  selector: 'app-restaurant-description',
  templateUrl: './restaurant-description.component.html',
  styleUrls: ['./restaurant-description.component.scss'],
  standalone: false,
})
export class RestaurantDescriptionComponent {
  @Input() restaurant?: Restaurant;

  constructor(private modalCtrl: ModalController) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
